export default __webpack_public_path__ + "static/media/turn-sharp-right.98583397.svg";